import React from 'react'
import { FormattedMessage } from 'react-intl'
import { getCurrentLanguage } from 'locale'

export const FILTERS_TITLE = (
    <FormattedMessage
        id="recommended_clans.filters.title"
        defaultMessage="Подбор клана учитывает ваши игровые предпочтения и активность"
    />
)

export const FILTERS_PLAYERS = (
    <FormattedMessage id="recommended_clans.filters.players" defaultMessage="Минимальный состав" />
)

export const FILTERS_ACTIVITY = (
    <FormattedMessage id="recommended_clans.filters.activity" defaultMessage="Выберите уровень игровой активности" />
)

export const FILTERS_ACTIVITY_FROM = (num) => {
    return <FormattedMessage id="recommended_clans.filters.activity.from" defaultMessage="от {num}" values={{ num }} />
}

export const FILTERS_LANGUAGE = (
    <FormattedMessage id="recommended_clans.filters.language" defaultMessage="Язык общения" />
)

export const FILTERS_ACTIVITY_PLATOON_TITLE = (
    <FormattedMessage id="recommended_clans.filters.activity.platoon.title" defaultMessage="Низкая активность" />
)
export const FILTERS_ACTIVITY_PLATOON_DESCRIPTION = (
    <FormattedMessage
        id="recommended_clans.filters.activity.platoon.description"
        defaultMessage="Награды из боевых походов без обязательного участия в клановых режимах."
    />
)

export const FILTERS_ACTIVITY_STRONGHOLD_TITLE = (
    <FormattedMessage
        id="recommended_clans.filters.activity.stronghold.title"
        defaultMessage="Средняя активность"
    />
)
export const FILTERS_ACTIVITY_STRONGHOLD_DESCRIPTION = (
    <FormattedMessage
        id="recommended_clans.filters.activity.stronghold.description"
        defaultMessage="Периодическое участие в клановых режимах, в основном — в Укрепрайоне."
    />
)

export const FILTERS_ACTIVITY_GLOBAL_MAP_TITLE = (
    <FormattedMessage
        id="recommended_clans.filters.activity.global_map.title"
        defaultMessage="Высокая активность"
    />
)
export const FILTERS_ACTIVITY_GLOBAL_MAP_DESCRIPTION = (
    <FormattedMessage
        id="recommended_clans.filters.activity.global_map.description"
        defaultMessage="Непосредственное участие в жизни клана: Укрепрайоны и Глобальная карта."
    />
)

export const FILTERS_SAVE = <FormattedMessage id="recommended_clans.filters.save" defaultMessage="Применить" />

export const FILTERS_CLOSE = <FormattedMessage id="recommended_clans.filters.close" defaultMessage="Отменить" />

const LANGUAGES = {
    ALBANIAN: 'sq',
    ARMENIAN: 'hy',
    AZERBAIJANI: 'az',
    BELARUSIAN: 'be',
    BOSNIAN: 'bs',
    BULGARIAN: 'bg',
    CHINESE_SIMPLIFY: 'zh',
    CHINESE_TRADITIONAL: 'zh-tw',
    CROATIAN: 'hr',
    CZECH: 'cs',
    DANISH: 'da',
    DUTCH: 'nl',
    ENGLISH: 'en',
    ESTONIAN: 'et',
    FINNISH: 'fi',
    FRENCH: 'fr',
    GEORGIAN: 'ka',
    GERMAN: 'de',
    GREEK: 'el',
    HUNGARIAN: 'hu',
    INDONESIAN: 'id',
    ITALIAN: 'it',
    JAPANESE: 'ja',
    KAZAKH: 'kk',
    KOREAN: 'ko',
    KYRGYZ: 'ky',
    LATVIAN: 'lv',
    LITHUANIAN: 'lt',
    MALAYSIAN: 'ms',
    MOLDAVIAN: 'mo',
    NORWEGIAN: 'no',
    PHILIPPINES: 'tl',
    POLISH: 'pl',
    PORTUGUESE: 'pt',
    ROMANIAN: 'ro',
    RUSSIAN: 'ru',
    SERBIAN: 'sr',
    SLOVAK: 'sk',
    SPANISH: 'es',
    SWEDISH: 'sv',
    TAJIK: 'tg',
    THAI: 'th',
    TURKISH: 'tr',
    TURKMEN: 'tk',
    UKRAINIAN: 'uk',
    UZBEK: 'uz',
    VIETNAMESE: 'vi',
}

export const REALM_LANGUAGE_CODES = {
    ru: [
        LANGUAGES.RUSSIAN,
        LANGUAGES.AZERBAIJANI,
        LANGUAGES.ARMENIAN,
        LANGUAGES.BELARUSIAN,
        LANGUAGES.ESTONIAN,
        LANGUAGES.GEORGIAN,
        LANGUAGES.KAZAKH,
        LANGUAGES.KYRGYZ,
        LANGUAGES.LATVIAN,
        LANGUAGES.LITHUANIAN,
        LANGUAGES.MOLDAVIAN,
        LANGUAGES.TAJIK,
        LANGUAGES.TURKMEN,
        LANGUAGES.UKRAINIAN,
        LANGUAGES.UZBEK,
    ],
    eu: [
        LANGUAGES.ENGLISH,
        LANGUAGES.ALBANIAN,
        LANGUAGES.ARMENIAN,
        LANGUAGES.AZERBAIJANI,
        LANGUAGES.BELARUSIAN,
        LANGUAGES.BOSNIAN,
        LANGUAGES.BULGARIAN,
        LANGUAGES.CROATIAN,
        LANGUAGES.CZECH,
        LANGUAGES.DANISH,
        LANGUAGES.DUTCH,
        LANGUAGES.ESTONIAN,
        LANGUAGES.FINNISH,
        LANGUAGES.FRENCH,
        LANGUAGES.GEORGIAN,
        LANGUAGES.GERMAN,
        LANGUAGES.GREEK,
        LANGUAGES.HUNGARIAN,
        LANGUAGES.ITALIAN,
        LANGUAGES.KAZAKH,
        LANGUAGES.KYRGYZ,
        LANGUAGES.LATVIAN,
        LANGUAGES.LITHUANIAN,
        LANGUAGES.MOLDAVIAN,
        LANGUAGES.NORWEGIAN,
        LANGUAGES.POLISH,
        LANGUAGES.PORTUGUESE,
        LANGUAGES.ROMANIAN,
        LANGUAGES.RUSSIAN,
        LANGUAGES.SERBIAN,
        LANGUAGES.SLOVAK,
        LANGUAGES.SPANISH,
        LANGUAGES.SWEDISH,
        LANGUAGES.TAJIK,
        LANGUAGES.TURKISH,
        LANGUAGES.TURKMEN,
        LANGUAGES.UKRAINIAN,
        LANGUAGES.UZBEK,
    ],
    na: [
        LANGUAGES.ENGLISH,
        LANGUAGES.PORTUGUESE,
        LANGUAGES.SPANISH,
    ],
    asia: [
        LANGUAGES.ENGLISH,
        LANGUAGES.JAPANESE,
        LANGUAGES.PHILIPPINES,
        LANGUAGES.THAI,
        LANGUAGES.CHINESE_TRADITIONAL,
        LANGUAGES.VIETNAMESE,
        LANGUAGES.INDONESIAN,
        LANGUAGES.MALAYSIAN,
        LANGUAGES.KOREAN,
    ],
    cn360: [
        LANGUAGES.CHINESE_SIMPLIFY,
    ],
}

export const MEMBERS_COUNT_ITEMS = [1, 10, 20, 30, 40, 50, 60, 70, 80, 90].map(num => ({
    name: String(num),
    value: num,
    caption: FILTERS_ACTIVITY_FROM(num),
}))

export const LIST_TYPES = {
    CHOICE_1: 'choice_1',
    CHOICE_2: 'choice_2',
    CHOICE_3: 'choice_3',
}

export const DEFAULT_LIST_TYPE = LIST_TYPES.CHOICE_2

export const DEFAULT_MEMBERS_COUNT = 1

export const DEFAULT_LANGUAGES = [getCurrentLanguage()]



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/Filters/constants.js